export default "__VITE_ASSET__ChHa_h95__"